import Vue from 'vue';
import { decimalToHexColor } from './utilsColor';
import { isChineseOrEmoji } from './utilsStr';
import { copyText, heyboxTimeFormat } from './utils';
import { CHANNEL_TYPES } from '_lib/constants/channel';
import { reportCopyInvite } from '_api/report';
import { REPORT_TEAM_TEXT_COPY } from '../constants/report';
import {
  DEFAULT_INVITE_TEMPLETE,
  DEFAULT_TEAM_PROMISE_TEMPLETE,
  DEFAULT_ROOM_ACTIVITY_TEMPLATE,
  DEFAULT_GROUP_CHAT_INVITE_TEMPLATE,
} from '../constants/invite';
import store from '@/store';
import { ROOM_ACTIVITY_STATE } from '_lib/constants/room';
import { IM_MSG_TYPE, IM_RECEIVE_TYPE, MESSAGE_CONTENT_COMPONENT } from '_lib/constants/IM';
import markdownToHtml from '_lib/MarkdownToHtml';
import { NOTICE_CARD_TYPE } from '_lib/constants/notice-card';
import { calcUserName } from '_lib/CalcUserInfo';
import { formatDateByTemplet, getStorage } from '_lib/utils/utils';
import router from '@/router';

// 获取房间头像字符串
export function getRoomIconStr(name, force_one_char = false) {
  if (!name) {
    return name;
  }
  const letters = Array.from(name);
  // 中文、emoji、长度为1则返回第一个字符
  if (force_one_char || letters.length === 1) {
    return letters[0];
  } else {
    if (isChineseOrEmoji(letters[0]) || isChineseOrEmoji(letters[1])) {
      return letters[0];
    } else {
      return letters[0] + letters[1];
    }
  }
}
/**
    根据当前房间的 roles_list 拿当前用户需要显示的权限组
    @param {Array} roleList - An array of role objects.
    @param {Array} userRoles - An array of role IDs.
    @returns {Object|null}
**/
export function userHoistRole(roleList, userRoles = []) {
  userRoles = userRoles || [];
  let visibleRoles = roleList.filter((role) => role.hoist === 1);
  for (let r of visibleRoles) {
    if (userRoles.includes(r.id)) {
      let color = "";
      if (r.color_list && r.color_list.length == 2) {
        color = r.color_list.map((c) => decimalToHexColor(c)).join(",");
      } else {
        color = r.color === -1 ? "" : decimalToHexColor(r.color);
      }
      return {
        img: r.icon,
        color,
        name: r.name,
      };
    }
  }

  return null;
}

// 生成邀请文案
export function inviteCodeTemplate(code, config = {}) {
  let { template } = config;
  if (!template) {
    const store = require("@/store").default;
    template =
      store.getters.global_config.share_copy || DEFAULT_INVITE_TEMPLETE;
  }

  const link = process.env.INVITE_BASE + "/" + code;
  template = template.replace(/\${link}/g, link);
  template = template.replace(/\${invite_code}/g, code);
  return template
}

export function copyInviteCode(code, config = {}, reportType) {
  let { cb, noToast } = config;
  reportType = reportType || REPORT_TEAM_TEXT_COPY.DEFAULT;
  try {
    const inviteText = inviteCodeTemplate(code, config)
    copyText(inviteText);
    !noToast && Vue.prototype.$toast.success("复制成功，向好友发送邀请链接");
    reportCopyInvite({
      type: reportType,
      code,
    });
    cb && cb();
  } catch (error) {
    console.log(error);
    Vue.prototype.$toast.error("复制失败");
  }
}

export function copyTeamText({ code, timeStr, nickname, title }) {
  try {
    const store = require("@/store").default;
    let template =
      store.getters.global_config.promise_content ||
      DEFAULT_TEAM_PROMISE_TEMPLETE;

    title = title || "无主题";
    template = template.replace(/\${invite_code}/g, code);
    template = template.replace(/\${title}/g, title);
    template = template.replace(/\${nickname}/g, nickname);
    template = template.replace(/\${time_str}/g, timeStr);
    copyText(template);
    Vue.prototype.$toast.success("复制成功，向好友发送分享信息");
    reportCopyInvite({
      type: REPORT_TEAM_TEXT_COPY.DEFAULT,
      code,
    });
  } catch (error) {
    console.log(error);
    Vue.prototype.$toast.error("复制失败");
  }
}

export function addChannelMembersDefault(channel) {
  if (!channel) return;
  // 默认如果语音频道没有member会是undefined，添加默认值为空数组
  if (CHANNEL_TYPES.has_audio_types.includes(channel.channel_type)) {
    if (!channel.members) {
      channel.members = [];
    }
  }
  return channel;
}

export function getRoleColorStyle({ color, color_list }) {
  if (Array.isArray(color_list) && color_list.length === 2) {
    const gradient_style =
      "color: transparent;background-clip: text;-webkit-background-clip: text;-webkit-text-fill-color: transparent;";
    return (
      gradient_style +
      `background-image: linear-gradient(90deg, ${decimalToHexColor(
        color_list[0]
      )} 0%, ${decimalToHexColor(color_list[1])} 100%);`
    );
  } else {
    return `color: ${decimalToHexColor(color)}`;
  }
}

export function getDownloadManagerInstance() {
  if (!window.downloadManager) {
    if (!window.downloadManagerInitPromise) {
      window.downloadManagerInitPromise = new Promise((resolve) => {
        import('_lib/DownloadManager').then(({ DownloadManager }) => {
          if (window.downloadManager) {
            resolve(window.downloadManager)
            return
          }
          DownloadManager.getInstance().init().then(res => {
            resolve(window.downloadManager)
          })
        })
      })
    }
    return window.downloadManagerInitPromise
  } else {
    if (window.downloadManagerInitPromise) {
      window.downloadManagerInitPromise = null
    }
    return new Promise(resolve => {
      resolve(window.downloadManager)
    })
  }
}

export function getBasicRoomData(data) {
  return data.map(v => ({
    room_avatar: v.room_avatar,
    room_id: v.room_id,
    room_name: v.room_name,
  }))
}

export function calRoomShortCutHeihgt(type, count, isOpen) {
  if (type === 'room') {
    return 54
  } else {
    if (!isOpen) return 54
    return (count + 1) * 54 + 4
  }
}

// 从公告内容中获取公告的封面
export function getContentCover(md){
  let url = ''
  const regex = /!\[(.*?)\]\((.*?)(?: "(.*?)")?\)/g;
  const match = regex.exec(md);
  if (match) {
    url = match[2];
  }
  return url;
}


// 获取该用户是否有发言限制
export function checkMemberHasLimitations(member, channel) {
  const { level, verified, user_id, roles = [] } = member
  const isManager = !!Vue.prototype.$permission.judge('ManageServer', channel, false, { user_info: {user_id}, roles: store.getters.cur_roles_list, my_roles: roles })
  if(isManager) return false
  const { level: levelLimit, verified: verifiedLimit } = store.getters.cur_room_talkable;
  if (levelLimit && level < levelLimit) {
    return true
  }
  if (verifiedLimit && !verified) {
    return true
  }
  return false
}

// 清除十分钟之前与自己一起语音过的用户
export function clearUsersChatBefore() {
  const chatUsers = JSON.parse(localStorage.getItem("chatUsers") || "[]")
  chatUsers.forEach((user, index) => {
    const { last_time } = user
    const now = new Date().getTime()
    const remainingTime = now - Number(last_time)
    if(remainingTime > 1000 * 60 * 10) {
      chatUsers.splice(index, 1)
    }
  })
  localStorage.setItem("chatUsers", JSON.stringify(chatUsers))
}

// 添加十分钟内与自己一起语音的用户
export function addUsersChatIn10Min(id) {
  const channel_data = store.getters.cur_channel_data
  if(!channel_data || !channel_data.members) return
  
  const chatUsers = JSON.parse(localStorage.getItem("chatUsers") || "[]")
  if(id) {
    addUserToChatUsers(id, chatUsers)
  } else {
    channel_data.members.forEach(member => {
      addUserToChatUsers(member.user_id, chatUsers)
    })
  }
  localStorage.setItem("chatUsers", JSON.stringify(chatUsers))
}

// 判断用户是否在十分钟内与自己语音过
export function judgeUserChatIn10Min(id) {
  clearUsersChatBefore()
  const channel_data = store.getters.cur_channel_data
  if(channel_data && channel_data.members) {
    let member = channel_data.members.find(member => member.user_id == id)
    if(member) return true
  } else {
    const chatUsers = JSON.parse(localStorage.getItem("chatUsers") || "[]")
    let member = chatUsers.find(member => member.user_id == id)
    if(member) return true
  }
  return false
}

// 存入语音过的用户
function addUserToChatUsers(user_id, chatUsers) {
  if(user_id == store.getters.user_info.user_id) return
  const user = chatUsers.find(item => item.user_id == user_id)
  if(user) {
    user.last_time = new Date().getTime()
  } else {
    chatUsers.push({
      user_id,
      last_time: new Date().getTime()
    })
  }
}

// 新手教程提示文字包装函数
const wrapperFunc = (str, maxLen, highlightHead) =>
  `<span class="tips-highlight" >${highlightHead}${
    str.length > maxLen ? str.slice(0, maxLen) + '...' : str
  }</span>`;

// 获取房间新手教程相关的省略信息
export function getEllipseText(list, tail, highlightHead = '#', maxLen = 10) {
  const lens = list.length;
  if (lens <= 2) {
    return list.map(str => wrapperFunc(str, maxLen, highlightHead)).join('和');
  }
  return (
    `${list.slice(0, 2).map(str => wrapperFunc(str, maxLen, highlightHead)).join('、')}和其他${lens - 2}个` +
    tail
  );
}

// 获取房间新手教程相关的省略信息
export function getExpendText(list, highlightHead = '#', maxLen = 10) {
  const wrapperFunc = (str) =>
    `<span class="tips-highlight" >${highlightHead}${
      str.length > maxLen ? str.slice(0, maxLen) + '...' : str
    }</span>`;

  const lens = list.length;
  if (lens <= 2) {
    return list.map(str => wrapperFunc(str, maxLen, highlightHead)).join('和');
  }
  return (
    `${list.slice(0, list.length - 1).map(str => wrapperFunc(str, maxLen, highlightHead)).join('、')}和${wrapperFunc(list[list.length - 1], maxLen, highlightHead)}`
  );
}

/** 
 * 判断是否有新手教程的配置
 * @param {Object} v - 当前房间信息 cur_room_whole_data
 * @return {Boolean} - 是否有新手教程的配置
 */
export function getHasNewMemberConfig(v){
  const is_visitor = v?.my_room_info?.is_visitor
  if(is_visitor) return false
  const isNotPublicRoom = !v?.room?.is_public
  if(isNotPublicRoom) return false
  const finished = v?.my_room_info?.customization?.finish
  if (finished === undefined || finished) return false
  if (!v.room) return false
  const { customization_switch, questions } = v.room.customization
  if (!customization_switch) return false
  return true
}

/**
 * 复制房间活动邀请码
 * @param {*} param0 
 */
export function copyActivityText({ code, nickname, title }) {
  try {
    const store = require("@/store").default;
    let template =
      store.getters.global_config.activity_content ||
      DEFAULT_ROOM_ACTIVITY_TEMPLATE;

    title = title || "无主题";
    template = template.replace(/\${invite_code}/g, code);
    template = template.replace(/\${title}/g, title);
    template = template.replace(/\${nickname}/g, nickname);
    copyText(template);
    reportCopyInvite({
      type: REPORT_TEAM_TEXT_COPY.ACTIVITY,
      code,
    });
    Vue.prototype.$toast.success('复制成功');
  } catch (error) {
    console.log(error);
    Vue.prototype.$toast.error("复制失败");
  }
}

// 获取房间活动状态
export function getActivityState(now, start){
  if (now >= start) {
    return ROOM_ACTIVITY_STATE.STARTED;
  } else {
    const diff = start - now;
    if (diff <= 60 * 60 * 1000) {
      return ROOM_ACTIVITY_STATE.SOON;
    } else {
      return ROOM_ACTIVITY_STATE.NOT_SOON;
    }
  }
}

// 获取房间活动状态文案
export function getActivityDateFormat(state, startTime){
  if(state === ROOM_ACTIVITY_STATE.STARTED){
    return `已开始`
  } else {
    return heyboxTimeFormat(startTime)
  }
}

// 检查新手引导问题是否有效
export function checkNewMemberGuideQuestionValid(questionList) {
  if (questionList.length === 0) {
    return false;
  }
  const haveIllegalAnswer = questionList.some((question) => {
    const { answers } = question;
    return (
      answers?.length === 0 ||
      answers?.some((answer) => {
        return (
          answer?.text?.length === 0 ||
          (answer?.channel_ids?.length === 0 && answer?.role_ids?.length === 0)
        );
      })
    );
  });
  return !haveIllegalAnswer;
}

// 对新IM消息做格式化处理
export function formatNewIMMsg (d, data, isOverlay = false) {
  // type=4为markdown格式，需要转化为html
  if ([IM_MSG_TYPE['markdown'], IM_MSG_TYPE['AtOrChannel']].indexOf(d.msg_type) >= 0) {
    d.msg = d.msg.replace(/!\[\]\((https:\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com\/pic\/\d+\.png)\)/g, '[图片]').replace(/\[custom(.*?)_(.*?)\]/g, '[表情]');
    // IM中处理msg时是直接修改引用值，这里就先注释处理
    // d.msg = markdownToHtml(d, false, isOverlay)
  }
  let msg = JSON.parse(JSON.stringify(d))
  msg.key = data.sequence
  if (msg.receive_type === IM_RECEIVE_TYPE.private) { // 私聊
    msg.card_type = NOTICE_CARD_TYPE['private_im']
    return msg
  }
  const room = store.getters.room_list.find(v => v.room_id == msg.room_id)
  msg.card_type = NOTICE_CARD_TYPE['channel_im']
  msg.avatar = room.room_avatar || 'default_room_avatar'
  msg.avatarType = 'rectangle'
  msg.title = calcUserName(msg) + `(${msg.channel_name}，${room.room_name})`

  // 判断是不是被AT
  if (msg.msg_type === IM_MSG_TYPE['AtOrChannel'] && msg.at_users?.find(v => v.user_id == store.getters.user_info.user_id)) {
    msg.msg = '@了你'
  }
  return msg
}

// 处理Overlay消息
export function handleOverlayMessage (msg, is_screen_share = false) {
  const user_base_info = msg.user_info?.user_base_info || {}
  const result = {
    im_seq: msg.im_seq,
    avatar: user_base_info.avatar || msg.avatar,
    name: calcUserName(user_base_info),
    msg: getLastMsgText(msg),
    in_audio: store.getters.cur_channel_data.members?.some(v => v.user_id == msg.user_id),
    user_id: user_base_info.user_id || msg.user_id,
  }
  if (result.msg === '[表情]' && is_screen_share) {
    result.sticker = msg.img
  }
  return result
}

// 获取简单的消息内容
export function getLastMsgText (msg, type) {
  const msgTypeStr = MESSAGE_CONTENT_COMPONENT(msg)
  let text = msg.msg
  if (msgTypeStr === 'teamCard' || msgTypeStr === 'teamCardV2') {
    text = '[组队卡片]'
  } else if (msgTypeStr === 'teamInvite') {
    text = '[组队邀约]'
  } else if (msgTypeStr === 'uploadFile') {
    text = '[文件]'
  } else if (msgTypeStr === 'text') {
    text = text
  } else if (msgTypeStr === 'sticker') {
    text = '[表情]'
  } else if (['img', 'textAndImg'].includes(msgTypeStr)) {
    text = '[图片]'
  } else if (msgTypeStr === 'ANCCard'){
    text = '[频道公告]'
  } else if (msgTypeStr === 'welcomeMsg'){ 
    const at_users = msg.at_users || []
    at_users.forEach(v => {
      text = text.replace(new RegExp(`@{id:${v.user_id}}`, 'g'), `@${v.nickname}`)
    })
  } else if (msgTypeStr === 'cdKey'){ 
    text = '[CDKEY已发送]'
  } else if (['voteAnc', 'vote'].includes(msgTypeStr)) { 
    text = '[投票]'
  } else if (msgTypeStr === 'customCard') { 
    text = '[卡片消息]'
  } else if (['post', 'unknownPost'].includes(msgTypeStr)) { 
    text = '[帖子详情]'
  } else if (msgTypeStr === 'postComment') { 
    text = '[评论详情]'
  } else if (msgTypeStr === 'fight') { 
    text = '[开黑名片]'
  } else if (msgTypeStr === 'miniProgram') { 
    text = '[小程序]'
  } else if (msgTypeStr === 'miniProDetail') { 
    if(msg.msg) {
      let msg_content = JSON.parse(msg.msg)
      text = `[${getMiniproCardName(msg_content.mini_pro_id)}卡片]`
    }
    else text = `[存档卡片]`
  } else if (msgTypeStr === 'screenShareGift') {
    text = '[好友赠礼]'
  } else if (msgTypeStr === 'feedbackCard') { 
    text = '[反馈消息]'
  } else { 
    text = '不支持的消息类型'
  }
  if (type === 'channel') {
    const letters = Array.from(msg.channel_name || '');
    let fristChar = letters[0] ? letters[0].toUpperCase() : ''
    text = `[${fristChar}]${msg.nickname}:${text}`
  }
  text = text.replace(/\[custom(.*?)_(.*?)\]/g, '[表情]');
  return text
}

// 获取小程序卡片名称
export function getMiniproCardName(mini_pro_id) {
  switch(mini_pro_id) {
    case 'face_shape':
      return '捏脸'
    default: 
      return '存档'
  }
}

/**
 * 检查房间是否被封禁，被封禁则展示弹窗
 * @param {*} response 接口的响应
 * @returns {Object|null}
 */
export function getBlockQueryConfig(response) {
  const { blocked_reason, blocked_until } = response.result
  const getTimeText = () => {
    const showTime = blocked_until === -1 ? '永久' : formatDateByTemplet(blocked_until)
    return blocked_until === -1 ? 
      '已被 <span class="text-tx-1">封禁</span>':
      `封禁至 <span class="text-tx-1">${showTime}</span>`
  }
  const toHome = () => {
    if(router.currentRoute.name !== 'home') {
      router.push({ name: 'home' })
    }
  }
  return {
    config: {
      title: `${blocked_until === -1 ? '' : '暂时'}无法加入该房间`,
      desc: `该房间因 <span class="text-tx-1">${blocked_reason}</span> 处罚封禁，${getTimeText()}`,
      confirm: {
        text: '我知道了',
      },
    },
    confirmCB: () => {
      toHome()
    },
    cancelCB: () => {
      toHome()
    }
  }
}

// 处理初始化时需要隐藏右边栏的组件
export async function handleCompHideRightSide() {
  // store中存在的数据
  const rightSideData = store.getters.show_friend_sidebar || store.getters.right_bar_module
  // 本地存储中的数据
  const storeRightSideData = await getStorage('room_last_show_right_sidebar')
  
  const originShowFriendSidebar = Boolean(rightSideData || storeRightSideData)
  store.commit('SET_SHOW_FRIEND_SIDEBAR', false)
  return originShowFriendSidebar
}

/**
 * 复制群聊邀请码
 * @param {Object} options 
 * @param {string} options.code 邀请码
 * @param {string} options.nickname 昵称
 * @param {string} options.title 标题
 */
export function copyGroupChatInviteCode(options) {
  try {
    const store = require("@/store").default;
    let template =
      store.getters.global_config.group_chat_content ||
      DEFAULT_GROUP_CHAT_INVITE_TEMPLATE;
    template = template.replace(/\${invite_code}/g, options.code);
    template = template.replace(/\${nickname}/g, options.nickname);
    template = template.replace(/\${title}/g, options.title);
    copyText(template);
    Vue.prototype.$toast.success('复制成功');
  } catch (error) {
    console.log(error);
    Vue.prototype.$toast.error("复制失败");
  }
}

/**
 * @description 判断是否正在观看屏幕共享
 * @param {Object} screen_sharing_info - 屏幕共享信息 from Vuex
 * @returns {Boolean}
 */
export function isWatchingScreenShare(screen_sharing_info) {
  return Boolean(screen_sharing_info.user_id);
}